
import { Step } from "@/lib/types";

export const warmupStep: Step = {
  id: "warmup",
  type: "step",
  title: "Warm-up your Tiktok account",
  description: "When creating a new Tiktok account, we need to show Tiktok we're actual humans and not a bot else Tiktok will shadowban us and our post will have low views. This step is super important!",
  todos: [],
  buttonText: "Start Warm-up Process",
  subSteps: []
};
